import { render, staticRenderFns } from "./MypageIndex.vue?vue&type=template&id=4a450822"
import script from "./MypageIndex.vue?vue&type=script&lang=js"
export * from "./MypageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports